import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tradesService } from '@/services/trades/trades-service';
import { tradesKeys } from '@/services/query-keys/trades-keys';

export const useGiveNotice = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, noticeDate }: { id: number; noticeDate?: string }) =>
      tradesService.giveNotice(id, noticeDate),
    onSuccess: () => {
      // Invalidate all trade-related queries to refresh the list
      queryClient.invalidateQueries({ queryKey: tradesKeys.all });
    },
  });
};
